import {Injectable} from "@angular/core";
import {VisbosService} from "../../../core/visbos-core/graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import gql from "graphql-tag";
import {ProductBatch} from "../../model/product-batch.type";
import {ProductBatchInput} from "../../model/product-batch-input.type";
import {Observable} from "rxjs/Observable";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store";
import {SessionActions} from "../../../shared/actions";
import {map} from "rxjs/operators";

export const productBatchFragments = {
  productBatch: gql`
    fragment ProductBatchFields on ProductBatch {
      cuid, label, batch_number, use_before_date, use_before_date_formatted
    }`
};

export const productFragments = {
  productPacking: gql`
    fragment ProductPackingFields on ProductPacking {
      cuid, label, article_number, default_packing, packing_amount,
      packing_unit { cuid, label, packing_unit_name, has_content },
      packing_price
    }
  `,
  product: gql`
    fragment ProductFields on Product {
      cuid, label, name, default_product,
      manufacturer {cuid, label, name},
      supplier {cuid, label, name},
      packings {cuid, label, article_number, default_packing, packing_amount,
        packing_unit { cuid, label, packing_unit_name, has_content },
        packing_price
      },
    }
  `
};

@Injectable()
export class ProductService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  public getProductBatches(searchString?: string, withDeleted?: boolean): ApolloQueryObservable<ProductBatch[]> {

    let query = this.fetchItems<ProductBatch[]>({
      query: gql`
        query FetchProductBatches($searchString: String, $withDeleted: Boolean) {
          productBatches(search_string: $searchString, with_deleted: $withDeleted) {
            ...ProductBatchFields
          }
        }
        ${productBatchFragments['productBatch']}
      `,
      variables: {
        searchString: searchString,
        withDeleted: withDeleted
      }
    });

    return <ApolloQueryObservable<ProductBatch[]>>query.pipe(map(({data}: any) => data.expiringStocks));
  }

  public addProductBatch(stockCuid: string, productBatch: ProductBatchInput): Observable<ProductBatch> {

    return this.mutate({
      mutation: gql`
        mutation AddProductBatch($stockCuid: String!, $productBatch: ProductBatchInput!) {
          addProductBatch(stock_cuid: $stockCuid, product_batch: $productBatch) {
            ...ProductBatchFields
          }
        }

        ${productBatchFragments['productBatch']}
      `,
      variables: {
        stockCuid: stockCuid,
        productBatch: productBatch
      }
    }).pipe(
      map(({data}: any) => {
        console.info("Added batch to stock.");
        return data.addProductBatch;
      }));

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/product-services/product.service.ts